import {createSlice} from "@reduxjs/toolkit";
import {getBookingDetail} from "./action";

const initialState = {
  state: {
    id: '',
    custom_id: '',
    auto_id: 0,
    type: '',
    label: '',
    status: '',
    coupon_code: '',
    total_price: 0,
    final_price: 0,
    customer_id: '',
    venue_id: '',
    subscription_id: '',
    booking_method_id: 0,
    invoice_id: '',
    created_at: 0,
    venue: {}
  },
  loading: true,
  error: ''
} as BaseState<BookingDetailState>

const slice = createSlice({
  name: 'bookingDetailSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getBookingDetail.pending, (state) => ({
        ...state,
        loading: true
      })
    )
    builder.addCase(getBookingDetail.fulfilled, (state, action) => ({
          state: { ...action.payload },
          loading: false,
          error: null
        }
      )
    )
    builder.addCase(getBookingDetail.rejected, (state) => ({
        ...state,
        loading: false,
        error: 'Failed to get booking detail, please try again'
      })
    )
  }
})

export default slice
